import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import ReactSlider from "react-slider";
import bannerBgVideo from "../../images/videos/banner-background-video.mp4";
import bannerBgVideo1 from "../../images/videos/siddhiananta-video.mp4";
import buyService from "../../images/Homepage/buy-service.png";
import commercialService from "../../images/Homepage/commercial-service.png";
import plotService from "../../images/Homepage/plot-service.png";
import sharmanJoshi from "../../images/Homepage/banner-joshi.png";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import generateSlug from "./generateSlug";
import UrltoSlug from "./UrlToSlug";
import { fetchDistricts } from "../../redux/districtsSlice";
import { Helmet } from "react-helmet";
const NewBanner = ({ category, handleQuery = "" }) => {
  // alert(category);
  const { districts, status, error1 } = useSelector((state) => state.districts);
  const [city, setCity] = useState("jaipur");
  const apiKey = "6095af4ca12142f8b0ddfff8bd689908";
  const location = useLocation();
  const [suggestions, setSuggestions] = useState([]);
  const searchBoxRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState([]);
  const [localityId, setlocalityId] = useState("1");
  const [formattedValue, setFormattedValue] = useState("");
  const [values, setValues] = useState([0, 50000000]);
  const hasFetched = useRef(false);
  const [metaDetail, setMetaDetail] = useState([]);
  const [underscoreValue, setUnderscoreValue] = useState(null);
  const [isBudgetOpen, setIsBudgetOpen] = useState(false);
  const [commercialServiceQuery, setCommericalServiceQuery] = useState("buy");
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [propertyType, setPropertyType] = useState("");
  const budgetRef = useRef(null);
  const toggleBudget = () => {
    setIsBudgetOpen(!isBudgetOpen);
  };
  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchDistricts());

      console.log("districts : : ", districts);
    }
  }, [dispatch, status]);
  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value); // Update the search query on input change
  };
  const fetchSuggestions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/getLocalities?query=${searchQuery}&localityId=${localityId}`
      );
      setSuggestions(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  const handleCommercialService = (e) => {
    setCommericalServiceQuery(e.target.value);
  };

  const handleSuggestionSelect = (suggestion) => {
    const title = {
      buy: "flats-for-sale-in-",
      home: "flats-for-sale-in-",
      rent: "flats-for-rent-in-",
      plot: "plots-for-sale-in-",
    };
    setSearchQuery(suggestion.name);
    setSuggestions([]);
    if (suggestion.category === "locality") {
      const cat = suggestion.id;
      const finalCategory =
        category === "plot" || category === "home" ? "buy" : category;
      const type = category === "commercial" ? commercialServiceQuery : "";
      const filter =
        category === "plot"
          ? localStorage.setItem("feature_clicked", "property_type:plot")
          : null;
      const text1 = `${finalCategory}/${
        finalCategory === "commercial" ? `${commercialServiceQuery}/` : ""
      }searches`;
      const text2 = `${suggestion?.property_location}-srlid-${cat}`;
      const extra = title[category];
      const url = `${text1}/${extra ?? "property-in-"}${UrltoSlug(text2)}`;

      navigate(`/${url}`, {
        state: {
          name: suggestion.name,
          service: category,
          type: type,
          filter: filter,
        },
      });
    } else if (suggestion.category === "city") {
      const cat = suggestion.id;
      const finalCategory =
        category === "plot" || category === "home" ? "buy" : category;
      const type = category === "commercial" ? commercialServiceQuery : "";
      const filter =
        category === "plot"
          ? localStorage.setItem("feature_clicked", "property_type:plot")
          : null;
      const text1 = `${finalCategory}/${
        finalCategory === "commercial" ? `${commercialServiceQuery}/` : ""
      }searches`;
      const text2 = `${suggestion?.property_location}-srcid-${cat}`;
      const extra = title[category];
      const url = `${text1}/${extra ?? "property-in-"}${UrltoSlug(text2)}`;
      navigate(`/${url}`, {
        state: {
          name: suggestion.name,
          service: category,
          type: type,
          filter: filter,
        },
      });
    } else if (suggestion.category === "sublocality") {
      const cat = suggestion.id;
      const finalCategory =
        category === "plot" || category === "home" ? "buy" : category; // Override 'plot' with 'buy'
      const type = category === "commercial" ? commercialServiceQuery : "";
      const filter =
        category === "plot"
          ? localStorage.setItem("feature_clicked", "property_type:plot")
          : null;
      const text1 = `${finalCategory}/${
        finalCategory === "commercial" ? `${commercialServiceQuery}/` : ""
      }searches`;
      const text2 = `${suggestion?.property_location}-srslid-${cat}`;
      const extra = title[category];
      const url = `${text1}/${extra ?? "property-in-"}${UrltoSlug(text2)}`;
      navigate(`/${url}`, {
        state: {
          name: suggestion.name,
          service: category,
          type: type,
          filter: filter,
        },
      });
    } else if (suggestion.category == "project") {
      const pid = suggestion?.id || "";
      const url = generateSlug(suggestion);
      window.location.href = url;
      localStorage.setItem(
        "last-property-seen",
        JSON.stringify({ id: pid, typeWithId: url })
      );
    }
  };

  const handlePropertyType = (e) => {
    setPropertyType(e.target.value);
  };

  const handleChange = (newValues) => {
    const split = (newValues + " ").split(",");
    if (split.length >= 2) {
      function formatCurrency(value) {
        if (value >= 10000000) {
          return `₹${(value / 10000000).toFixed(2)}Cr`; // Crores
        } else if (value >= 100000) {
          return `₹${(value / 100000).toFixed(2)}L`; // Lakhs
        } else if (value >= 1000) {
          return `₹${(value / 1000).toFixed(2)}K`; // Thousands
        } else {
          return `₹${value}`; // Less than 1000
        }
      }
      if (parseInt(split[0]) === 49999999) {
        setFormattedValue(`${formatCurrency(split[0])} +`);
      } else {
        setFormattedValue(
          `${formatCurrency(split[0])} - ${formatCurrency(split[1])}`
        );
      }
    } else {
      alert("Invalid input format");
    }
    setValues(newValues);
  };

  const getCityFromCoordinates = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://api.opencagedata.com/geocode/v1/json?q=${lat}+${lon}&key=${apiKey}`
      );
      const data = await response.json();

      const result = data?.results?.[0]?.components;
      const cityName =
        result?.state_district ||
        result?.city ||
        result?.town ||
        result?.village ||
        null;

      if (cityName) {
        setCity(cityName);
        setCookie("city", cityName);
      } else {
        setError("City not found");
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setError("Error fetching city name");
    }
  };

  // Get a cookie by name
  const getCookie = (name) => {
    const match = document.cookie.match(
      new RegExp("(^| )" + name + "=([^;]+)")
    );
    return match ? decodeURIComponent(match[2]) : null;
  };
  const setCookie = (name, value, days = 7) => {
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(
      value
    )}; expires=${expires}; path=/`;
  };

  useEffect(() => {
    const cachedCity = getCookie("city");
    if (cachedCity) {
      setCity(cachedCity);
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          getCityFromCoordinates(latitude, longitude);
        },
        () => setError("Unable to retrieve your location.")
      );
    } else {
      setError("Geolocation is not supported by this browser.");
    }
  }, []);

  useEffect(() => {
    const path = location.pathname;
    const pathSegments = path.split("/").filter(Boolean);
    if (pathSegments.length === 0) return;
    const lastSegment = pathSegments[pathSegments.length - 1];
    const lastPart = lastSegment.split("-").pop();
    if (lastPart.includes("_")) {
      setUnderscoreValue(lastPart);
      console.log("✅ Extracted:", lastPart);
    } else {
      console.log("❌ No underscore value found.");
    }
  }, [location.pathname]);

  // alert(
  //   city
  // );
  useEffect(() => {
    if (category == "commercial") {
      handleQuery(commercialServiceQuery);
    }
  }, [category, commercialServiceQuery]);
  let slug = "";
  useEffect(() => {
    const fetchCitySlug = async () => {
      if (hasFetched.current) return;
      let cityId = null;
      try {
        if (underscoreValue) {
          const cityResponse = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/get/city_by_slug`,
            { slug: underscoreValue, category }
          );
          if (cityResponse.data?.status == false) {
            console.warn("❌ City not found for slug:", underscoreValue);
            navigate("/not_found");
            return;
          } else {
            cityId = cityResponse.data?.city_id;
            const metaTag = cityResponse.data?.meta_tags;
            setMetaDetail(metaTag);
            // let slugTitle = metaTag[0].url_slug || "";
            // if (slugTitle) {
            //   window.history.replaceState({}, "", slugTitle);
            // }
          }
        } else if (city && !underscoreValue) {
          const slugResponse = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/get/city_slug`,
            { city: city, category }
          );
          const citySlug = slugResponse.data?.city_slug;
          const metaTag = slugResponse.data?.meta_tags;
          setMetaDetail(slugResponse.data?.meta_tags);
          slug = metaTag[0].url_slug || "";
          // if (citySlug) {
          //   const baseUrl = window.location.origin;
          //   const newUrl = `${baseUrl}/${
          //     category !== "home" ? category + "/" : ""
          //   }${slug}`;
          //   // window.history.replaceState({}, "", newUrl);
          //   // hasFetched.current = true;
          // }
        }
      } catch (error) {
        console.error("❌ Error fetching city slug:", error);
      }
    };
    fetchCitySlug();
  }, [underscoreValue, city, category]);
  useEffect(() => {
    if (searchQuery.length > 2) {
      fetchSuggestions();
    } else {
      setSuggestions([]);
    }
  }, [searchQuery]);
  function slugToTitle(slug) {
    if (!slug) return "";
    let cleanSlug = slug;
    cleanSlug = cleanSlug.replace(/_/g, "-");
    let words = cleanSlug.split("-").map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return words.join(" ");
  }

  const metaData =
    metaDetail?.find((item) => item.category_id === category) ||
    metaDetail?.[0];

  return (
    <>
      <Helmet>
        <title>
          {metaData?.category_id === "home"
            ? slugToTitle(metaData?.meta_title)
            : slugToTitle(metaData?.url_slug)}
        </title>

        <meta name="description" content={metaData?.meta_description || ""} />
        <meta name="keywords" content={metaData?.meta_keyword || ""} />

        <meta
          property="og:title"
          content={
            metaData?.category_id === "home"
              ? slugToTitle(metaData?.meta_title)
              : slugToTitle(metaData?.url_slug)
          }
        />
        <meta
          property="og:description"
          content={metaData?.meta_description || ""}
        />
        <meta
          property="og:image"
          content={
            metaData?.og_image ||
            "https://dreamsakha.rusofterp.in/public/webimage/setting/174591535068108dd6e4ebasid.png"
          }
        />
        <meta
          property="og:url"
          content={typeof window !== "undefined" ? window.location.href : ""}
        />

        <meta name="robots" content="index, follow" />
      </Helmet>
      <section className="siddhi-banner-section position-relative">
        <video
          className="position-absolute w-100 h-100 object-fit-cover"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={bannerBgVideo1} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="siddhi-banner-container">
          <div className="siddhi-banner-overlay position-absolute"></div>
          <div className="categorybox mob">
            <div className="catheads">
              {/* <div
                className={`cats buy cats_width ${
                  category === "buy" || category === "home"
                    ? `active_${category}`
                    : ""
                }`}
              >
             
                <a
                  href={`/buy/${
                    metaDetail?.find((item) => item.category_id === "buy")
                      ?.url_slug ?? ""
                  }`}
                >
                  <div
                    className={`catname ${
                      category === "buy" || category === "home"
                        ? `active_${category}`
                        : ""
                    }`}
                  >
                    BUY
                  </div>
                </a>
              </div> */}

              <div
                className={`cats plot cats_width ${
                  category === "plot" ? `active_${category}` : ""
                }`}
              >
                <a
                  href={`/plot/${
                    metaDetail?.find((item) => item.category_id === "plot")
                      ?.url_slug ?? ""
                  }`}
                >
                  <div
                    className={`catname ${
                      category === "plot" ? `active_${category}` : ""
                    }`}
                  >
                    PLOTS
                  </div>
                </a>
              </div>

              {/* <div
                className={`cats commercial cats_width ${
                  category === "commercial" ? `active_${category}` : ""
                }`}
              >
               
                <a
                  href={`/commercial/${
                    metaDetail?.find(
                      (item) => item.category_id === "commercial"
                    )?.url_slug ?? ""
                  }`}
                >
                  <div
                    className={`catname ${
                      category === "commercial" ? `active_${category}` : ""
                    }`}
                  >
                    COMMERCIAL
                  </div>
                
                </a>
              </div> */}
            </div>

            <div>
              <div className="homesearch">
                {districts.length > 0 && (
                  <select
                    className=" form-control locationtxt desk"
                    id="select_city"
                    disabled={"true"}
                  >
                    <option value="" selected>
                      Jaipur
                    </option>
                    {districts.map((district, index) => (
                      <>
                        <option
                          key={index}
                          value={district.id}
                          selected={
                            city.toLowerCase() === district.name.toLowerCase()
                              ? "selected"
                              : ""
                          }
                        >
                          {district.name}
                        </option>
                      </>
                    ))}
                  </select>
                )}

                <div className="searchtxtbox" ref={searchBoxRef}>
                  <div style={{ display: "flex" }}>
                    <input
                      id="search_bar"
                      type="text"
                      className="form-control"
                      placeholder="Search for locality, landmark"
                      aria-label="Search for locality, landmark"
                      value={searchQuery}
                      onChange={(e) => handleSearchInputChange(e)}
                      onClick={() => fetchSuggestions()}
                      style={{ border: "none" }}
                    />
                    {category === "commercial" && (
                      <div className="commercial-service">
                        <input
                          id="buy"
                          type="radio"
                          name="commercial-service"
                          value="buy"
                          onChange={(e) => handleCommercialService(e)}
                          checked={commercialServiceQuery === "buy"}
                        />
                        <label htmlFor="buy">Buy</label>

                        <input
                          id="lease"
                          type="radio"
                          name="commercial-service"
                          value="lease"
                          onChange={(e) => handleCommercialService(e)}
                          checked={commercialServiceQuery === "lease"}
                        />
                        <label htmlFor="lease">Lease</label>
                      </div>
                    )}
                  </div>
                  {suggestions.length > 0 && (
                    <ul className="suggestions-list">
                      {suggestions.map((suggestion, index) => (
                        <li
                          key={index}
                          onClick={() => handleSuggestionSelect(suggestion)}
                        >
                          <span
                            style={{ color: "#343434" }}
                            className="suggestion-name"
                          >
                            {suggestion.name ?? ""}
                          </span>
                          <span
                            style={{ color: "lightgrey" }}
                            className="suggestion-category"
                          >
                            {suggestion.category ?? "Locality"}
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                <div className="select-box hidefornow">
                  <select
                    className=" propertytype"
                    id="propertytype"
                    onChange={handlePropertyType}
                  >
                    <option value="" selected>
                      Property Type-----
                    </option>
                    <option value="1bhk">1 BHK</option>
                    <option value="2bhk">2 BHK</option>
                    <option value="3bhk">3 BHK</option>
                    <option value="penthouse">Pent House</option>
                    <option value="villa">Villa</option>
                    <option value="flats">Flat/Apartment</option>
                  </select>
                </div>

                <div className="budgetouter hidefornow" ref={budgetRef}>
                  <div
                    htmlFor="budget"
                    className="form-select budgetsel"
                    onClick={toggleBudget}
                  >
                    <p>Budget {formattedValue}</p>
                  </div>

                  <div
                    className={`budgetbox ${
                      isBudgetOpen ? "slide-down" : "d-none"
                    }`}
                  >
                    <input
                      className="budgetinput"
                      id="budget"
                      type="text"
                      value={`₹${values[0]} - ₹${values[1]}`}
                      readOnly
                    />
                    <ReactSlider
                      className="horizontal-slider"
                      thumbClassName="thumb"
                      trackClassName="track"
                      value={values}
                      onChange={handleChange}
                      min={0}
                      max={50000000}
                      pearling
                      minDistance={1}
                      renderThumb={(props) => <div {...props}></div>}
                    />
                  </div>
                </div>

                <button
                  onClick={() =>
                    handleSuggestionSelect({
                      id: 1,
                      name: "Jaipur",
                      location: "1",
                      developer: "",
                      category: "city",
                      property_location: "Jaipur-Rajasthan",
                    })
                  }
                  className="btn searchbtn base"
                  type="button"
                >
                  <span className="search">Search</span>
                </button>
              </div>
            </div>
          </div>
          <div className="sharman-img mob">
            <img src={sharmanJoshi} alt="Sharman Joshi" />
          </div>
        </div>
        <div className="service-card-stack ">
          {/* <div className="service-card">
            <a
              href={`/buy/${
                metaDetail?.find((item) => item.category_id === "buy")
                  ?.url_slug ?? ""
              }`}
            >
              <img src={buyService} alt="Buy" />
            </a>
          </div> */}
          <div className="service-card">
            <a
              href={`/plot/${
                metaDetail?.find((item) => item.category_id === "plot")
                  ?.url_slug ?? ""
              }`}
            >
              <img src={plotService} alt="Plot" style={{ width: "50%" }} />
            </a>
          </div>
          {/* <div className="service-card">
            <a
              href={`/commercial/${
                metaDetail?.find((item) => item.category_id === "commercial")
                  ?.url_slug ?? ""
              }`}
            >
              <img src={commercialService} alt="Commercial" />
            </a>
          </div> */}
        </div>
        <div
          className="desk"
          style={{
            position: "absolute",
            zIndex: "99",
            top: "28%",
            left: "0",
            right: "0",
          }}
        >
          
          <div className="mb-5" style={{width: '478px', margin: 'auto', position: 'relative'}}>
            <p className="banner_tm">TM</p>
            <h1 className="siddhi-title-name">Siddhi Ananta</h1>
            <h5 className="siddhi-title-name2">Group</h5>
            <h5 className="siddhi-title-name3">सपने आपके, शुरुआत हमारी</h5>
          </div>

          <div className="homesearch">
            {districts.length > 0 && (
              <select
                className=" form-control locationtxt desk"
                id="select_city"
                disabled={"true"}
              >
                <option value="" selected>
                  Jaipur
                </option>
                {districts.map((district, index) => (
                  <>
                    <option
                      key={index}
                      value={district.id}
                      selected={
                        city.toLowerCase() === district.name.toLowerCase()
                          ? "selected"
                          : ""
                      }
                    >
                      {district.name}
                    </option>
                  </>
                ))}
              </select>
            )}

            <div className="searchtxtbox" ref={searchBoxRef}>
              <div style={{ display: "flex" }}>
                <input
                  id="search_bar"
                  type="text"
                  className="form-control"
                  placeholder="Search for locality, landmark"
                  aria-label="Search for locality, landmark"
                  value={searchQuery}
                  onChange={(e) => handleSearchInputChange(e)}
                  onClick={() => fetchSuggestions()}
                  style={{ border: "none" }}
                />
                {category === "commercial" && (
                  <div className="commercial-service">
                    <input
                      id="buy"
                      type="radio"
                      name="commercial-service"
                      value="buy"
                      onChange={(e) => handleCommercialService(e)}
                      checked={commercialServiceQuery === "buy"}
                    />
                    <label htmlFor="buy">Buy</label>

                    <input
                      id="lease"
                      type="radio"
                      name="commercial-service"
                      value="lease"
                      onChange={(e) => handleCommercialService(e)}
                      checked={commercialServiceQuery === "lease"}
                    />
                    <label htmlFor="lease">Lease</label>
                  </div>
                )}
              </div>
              {suggestions.length > 0 && (
                <ul className="suggestions-list">
                  {suggestions.map((suggestion, index) => (
                    <li
                      key={index}
                      onClick={() => handleSuggestionSelect(suggestion)}
                    >
                      <span
                        style={{ color: "#343434" }}
                        className="suggestion-name"
                      >
                        {suggestion.name ?? ""}
                      </span>
                      <span
                        style={{ color: "lightgrey" }}
                        className="suggestion-category"
                      >
                        {suggestion.category ?? "Locality"}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="select-box hidefornow">
              <select
                className=" propertytype"
                id="propertytype"
                onChange={handlePropertyType}
              >
                <option value="" selected>
                  Property Type-----
                </option>
                <option value="1bhk">1 BHK</option>
                <option value="2bhk">2 BHK</option>
                <option value="3bhk">3 BHK</option>
                <option value="penthouse">Pent House</option>
                <option value="villa">Villa</option>
                <option value="flats">Flat/Apartment</option>
              </select>
            </div>

            <div className="budgetouter hidefornow" ref={budgetRef}>
              <div
                htmlFor="budget"
                className="form-select budgetsel"
                onClick={toggleBudget}
              >
                <p>Budget {formattedValue}</p>
              </div>

              <div
                className={`budgetbox ${
                  isBudgetOpen ? "slide-down" : "d-none"
                }`}
              >
                <input
                  className="budgetinput"
                  id="budget"
                  type="text"
                  value={`₹${values[0]} - ₹${values[1]}`}
                  readOnly
                />
                <ReactSlider
                  className="horizontal-slider"
                  thumbClassName="thumb"
                  trackClassName="track"
                  value={values}
                  onChange={handleChange}
                  min={0}
                  max={50000000}
                  pearling
                  minDistance={1}
                  renderThumb={(props) => <div {...props}></div>}
                />
              </div>
            </div>

            <button
              onClick={() =>
                handleSuggestionSelect({
                  id: 1,
                  name: "Jaipur",
                  location: "1",
                  developer: "",
                  category: "city",
                  property_location: "Jaipur-Rajasthan",
                })
              }
              className="btn searchbtn base"
              type="button"
            >
              <span className="search">Search</span>
            </button>
          </div>
        </div>
        <div className="sharman-img desk">
          <img src={sharmanJoshi} alt="Sharman Joshi" />
        </div>
      </section>
    </>
  );
};

export default NewBanner;
